/// <summary>
/// This object does the complete menu and highchart handling in the sankey. <br/>
/// It generates proper ramp and ramp signal parameters, does the date handling and menu hiding/showing stuff. 
/// Author: MWI<br />
/// Date: 5.10.2015<br />
/// Copyright ©: EUDT GmbH 2015 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.6 - 07.09.2016                                                *<br />
/// **********************************************************************<br />
/// * - now does not show subsignal icon if only 1 child                  *<br />
/// **********************************************************************<br />
/// *** v1.0.6 - 07.09.2016                                                *<br />
/// **********************************************************************<br />
/// * - capture of error when no topology available                      *<br />
/// **********************************************************************<br />
/// *** v1.0.5 - 15.04.2016                                                *<br />
/// **********************************************************************<br />
/// * - added documentation and                                           *<br />
/// * - added missing try catch blocks                                    *<br />
/// * - added filter for nodes that only have special children            *<br/>
/// **********************************************************************<br />
/// *** v1.0.4 - 07.04.2016                                                *<br />
/// **********************************************************************<br />
/// * - resharper changes                                                *<br />
/// **********************************************************************<br />
/// *** v1.0.3 - 30.03.2016                                                *<br />
/// **********************************************************************<br />
/// * - resharper changes                                                *<br />
/// **********************************************************************<br />
/// *** v1.0.2 - 22.02.2016                                                *<br />
/// **********************************************************************<br />
/// * - fixed bug with help dialog being to small                         *<br />
/// * - doEvent now calls method of vcSignalTopology                      *<br /> 
/// **********************************************************************<br />
/// *** v1.0.1 - 26.01.2016                                                *<br />
/// **********************************************************************<br />
/// * -  added basic possibility to select start point                   *<br />
/// * -  added DEveloplment option for Sys-Admins                        *<br />
/// **********************************************************************<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 5.10.2015                                                *<br />
/// **********************************************************************<br />
/// * -  inherited from vcSignalTopology js                              *<br />
/// * -  changed only a few functions                                    *<br />
/// **********************************************************************<br />
/// </summary>


function vcTopologySankey(options) {
    ///<summary>
    ///object constructor calling the super class
    ///</summary>
    var me = this;
    try {

        me.COCKPIT_START_SCALE_MIN_WIDTH = 1500; //default 1500

        me.COCKPIT_START_SCALE_XSMALL = 1; //default 1.8
        me.COCKPIT_START_SCALE_ADJUST_ALIGNMENT_XSMALL = 0; //default 100

        //smaller SCALE MIN WIDTH
        me.COCKPIT_START_SCALE_SMALL = 1.3; //default 1.3
        me.COCKPIT_START_SCALE_ADJUST_ALIGNMENT_SMALL = 70; //default 70

        //larger SCALE MIN WIDTH                               
        me.COCKPIT_START_SCALE_LARGE = 1.8; //default 1.8
        me.COCKPIT_START_SCALE_ADJUST_ALIGNMENT_LARGE = 100; //default 100

        window.vcSignalTopology.call(me, options);
    } catch (ex) {
        window.writeError("vcTopologySankey.constructor", ex);
    }
}
vcTopologySankey.prototype = Object.create(window.vcSignalTopology.prototype);
vcTopologySankey.prototype.constructor = window.vcSignalTopology;
vcTopologySankey.prototype.init = function () {
    ///<summary>
    ///inits the topo by calling the "super" Method and loading the sankey values
    ///</summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }


        me.myData = JSON.parse(me.settings.data.completeTree);
        if (!me.myData.children || me.myData.children.length < 1) {
            //$("#divContent").remove();
            $("#divMenu.rampmenu.sankey, #start, #baseHeader").remove();
            $("#divRamp1").css({ "width": "100%" });
            me.showInfo(me.resources.noEntriesExist, "", false);
            me.visual.find("#divTreeTop, #treeHolder, #start").hide();
            return true;
        } else {
            me.selStart = window.$("#start");
            me.isNormalScreen = true;
            me.categoryColors = window.Highcharts.getOptions().colors.slice();
            me.categoryColors[5] = "#b32f2f";
            window.vcSignalTopology.prototype.init.call(me);

            me.visual = $(".sankeyContainer");
            me.visual.find("#start .vc-filter").vcFilter({ callback: function () { me.filterSignalList(); } });

            var w = 350;
            var h = 50;
            var pattern = me.baseSvg.append("g")
                .attr("width", w)
                .attr("height", h)
                .attr("id", "myPattern").attr("class", "none")
                .attr("transform", "translate(28,18)");

            var categories = ["0-20%", "20-40%", "40-60%", "60-80%", "80-100%", ">=100%"];
            for (var i = 0; i <= 5; i++) {
                var c = me.categoryColors[i];
                pattern.append("rect")
                    .attr("height", h - 30 + "px")
                    .attr("width", w / 5)
                    .attr("x", (w / 5) * i)
                    .attr("fill", c).attr("style", "fill-opacity:0.4");
                pattern.append("text").attr("x", (w / 5) * i).attr("y", -5).text(categories[i]);
            }
            me.nodes.filter(function (d) {
                return me.filterLeaveNodes(d, me);
            }).sort(function (a, b) {
                if (a.bsagid < b.bsagid) {
                    return -1;
                } else {
                    if (a.sortid < b.sortid) {
                        return -1;
                    } else {
                        if (a.count < b.count) {
                            return -1;
                        } else {
                            return 0;
                        }
                    }
                }
            }
            ).forEach(function (d) {
                me.addValidStartNodesToDropdown(d, me);
            });
            me.selStart.find("#selStartPoint li:first-child").data("selected", true).addClass("selected");

            me.selStart.find("#selStartPoint li").filter(":even").addClass("alt");

            me.selStart.find("#selStartPoint li .btnSignalInfo").off("click").on("click",
                function (event) {
                    event.stopPropagation();
                    me.callMenuItemInfo(this);
                });
            me.addSankeyValues();
            me.setStartNode();
            me.setRemoved();

            me.selStart.css({ "height": $(".Topo").height(), "box-sizing": "border-box", "overflow": "hidden" });
            $("#selStartPoint").height(me.selStart.height() - 81);

            return true;
        }
    } catch (ex) {
        me.writeError("sankeyInit", ex);
        return false;
    }
};
vcTopologySankey.prototype.appendStyleElement = function (nodeEnter) {
    ///<summary>
    ///creates all styling elements for the sankey <br/>
    ///this function is a called by the vcSignalTopology <br/>
    ///e.g. does not create circles, but adds the subsignal info 
    ///</summary>
    var me = this;
    try {

        if (me.error) {
            return false;
        }
        me.visit(me.root,
            me.calculateSankeyPercentages,
            function (d) {
                return d.children && d.children.length > 0 ? d.children : null;
            },
            me);

        if (me.ieVersion === -1 || me.ieVersion > 11) {
            me.appendStyleElementNotIe(nodeEnter);
        } else {
            me.appendStyleElementIE(nodeEnter);
        }

        window.$("#node-1_-1 .nodeErr").remove();

        //window.d3.select("#node-1_-1").select(".nodeErr").remove();
        return true;
    } catch (ex) {
        me.writeError("vcTopologySankey.appendStyleElement", ex);
        return false;
    }
};
vcTopologySankey.prototype.appendStyleElementIE = function (nodeEnter) {
    var me = this;
    var text;
    try {
        text = nodeEnter.filter(me.filterRootNode).select(".nodeText");
        text.append("tspan")
            .style("fill-opacity", 1).attr("dy", "1.5em").attr("text-anchor", function (d) {
                if (me.settings.data.OnlyFirstLevel === true && d.depth === 2) {
                    return "start";
                } else {
                    return "end";
                }
            }).attr("class", function (d) {
                if (d.name.length >= 40) {
                    return "nodeValues  spanText long";
                } else {
                    return " nodeValues spanText";
                }
            });

        nodeEnter.append("text")
            .attr("class", "extraFont fa fa-lg nodeErr none")
            .attr("style", "font-size:1.5em; fill:#b32f2f;")
            .text("\uf071")
            .on("click", function (d) { me.showErrorInfo(d); }).attr("x", 0).attr("dx", me.nodeWidth - 65).attr("dy", "0.5em");


        if (!me.settings.data.archiveParam) {
            nodeEnter.filter(function (d) { return me.filterLeaveNodes(d, me); }).classed("withSub", true)
                .append("text")
                .attr("class", "extraFont fa fa-lg nodeSub color-fill-secondary")
                .attr("style", "font-size:1.5em")
                .text("\uf200")
                .attr("x", me.nodeWidth - 45)
                .attr("dy", "0.5em")
                .on("click",
                    function (d) {
                        me.callSubSignalInfo(me, d);
                    });
            nodeEnter.select(".nodeInfo").attr("dy", "0.5em").attr("x", 0).attr("dx", me.nodeWidth - 20);
            text.select(".nodeName").attr("dy", "-0.2em").attr("dx", 0).attr("x", me.nodeWidth - 50);
            text.select(".nodeValues").attr("dx", 0).attr("x", (me.nodeWidth - 50));
            nodeEnter.filter(function (d) { return !me.filterLeaveNodes(d, me); }).classed("woSub", true)
                .select(".nodeName").attr("x", me.nodeWidth - 30);
            nodeEnter.filter(function (d) { return !me.filterLeaveNodes(d, me); }).select(".nodeValues")
                .attr("x", me.nodeWidth - 30);
            me.linkRemoved = false;

        } else {
            text.select(".nodeName").attr("dx", function (d) {
                if (me.settings.data.OnlyFirstLevel === true && d.depth === 2) {
                    return 40;
                } else {
                    return 0;
                }
            });
            text.select(".nodeValues").attr("dx", function (d) {
                if (me.settings.data.OnlyFirstLevel === true && d.depth === 2) {
                    return 40;
                } else {
                    return 0;
                }
            });

        }
    } catch (ex) {
        me.writeError("vcTopologySankey.appendStyleIE", ex);
    }
};
vcTopologySankey.prototype.appendStyleElementNotIe = function (nodeEnter) {
    var me = this;
    var text;
    try {
        text = nodeEnter.filter(me.filterRootNode).select(".nodeTextContent");
        var values = text.append("div").attr("class", function (d) {
            if (d.name.length >= 40) {
                return "nodeValues long";
            } else {
                return " nodeValues";
            }
        });
        values.append("div").attr("class", "nodeValue");
        values.append("i")
            .attr("class", "extraFont fa fa-lg nodeErr none icon-color-error fa-exclamation-triangle")
            .on("click", function (d) { me.showErrorInfo(d); });

        if (!me.settings.data.archiveParam) {
            nodeEnter.filter(function (d) { return me.filterLeaveNodes(d, me); }).classed("withSub", true)
                .select(".nodeTextDiv")
                .insert("i", ".nodeTextContent")
                .attr("class", "extraFont fa fa-lg nodeSub color-font-secondary fa-chart-pie")
                .on("click",
                    function (d) {
                        me.callSubSignalInfo(me, d);
                    });
            me.linkRemoved = false;

        }
    } catch (ex) {
        me.writeError("vcTopologySankey.appendStyleNotIe", ex);

    }
};
vcTopologySankey.prototype.showErrorInfo = function (d) {
    var me = this;
    var sToolTip = "";
    try {
        sToolTip += "<b>" + d.name + "</b><br/>";
        if (d.valid === false) {
            sToolTip += me.settings.resources.dataInvalid;
        }
        if (d.plausible === false) {
            sToolTip += "<br/>" + me.settings.resources.dataInplausible;
        }
        if (d.containsNull === true) {
            sToolTip += "<br/>" + me.settings.resources.emptyValuesPadded;
        }
        if (d.noData === true) {
            sToolTip += "<br/>" + me.settings.resources.noData;
            if (me.settings.isPrice === true) {
                sToolTip += " (" + me.settings.resources.noPrice + ")";
            }
        }
        me.openInfoDialog(sToolTip,
            {
                "my": "top",
                "of": $("#node" + d.signalid + "_" + d.count),
                "at": "bottom"
            }
        );

    } catch (ex) {
        me.writeError("vcTopologySankey.showErrorInfo", ex);
    }

};
vcTopologySankey.prototype.filterLeaveNodes = function (d, me) {
    ///<summary>
    ///filters out all leave nodes for the nodeInfo <br/>
    ///+ tries to filter nodes that only have special children
    ///</summary>
    try {
        if (me.error) {
            return false;
        }

        var bRet = me.hasChildStatus(d.childStatus, me.ENUM_CHILD_STATUS.NONE) || (me.hasChildStatus(d.childStatus, me.ENUM_CHILD_STATUS.SPECIAL_SHOWN) && !me.hasChildStatus(d.childStatus, me.ENUM_CHILD_STATUS.SHOWN));
        if (d.isGenerator === "True") {
            bRet = true;
        }
        if ((d.children && d.children.length <= 1) || (d._children && d._children.length <= 1)) {
            bRet = true;
        }
        if ((d.specialChildren && d.specialChildren.length <= 1) || (d._specialChildren && d._specialChildren.length <= 1)) {
            bRet = true;
        }
        if (d.isInternal) {
            bRet = true;
        }
        if (d.isActive === false) {
            bRet = true;
        }
        return !bRet;
    } catch (ex) {
        me.writeError("sankey.filterLeaveNodes", ex);
        return false;
    }
};
vcTopologySankey.prototype.calculateSankeyPercentages = function (d, me) {
    /// <summary>Calculates what percent a node in the current subtree has <br/>
    /// * needs to account for special cases <br/>
    /// * adds circleSize, percentages and such directly to the node</summary>
    /// <param name="d" type="Node">the node to calculate the percentage for</param>
    try {
        if (me.error) {
            return false;
        }

        if (d.value !== 0) { //check whether anything at all happened at the signal
            window.d3.select("#node" + d.id).select(".nodeSub").classed("none", false);

            var rootvalue = 0;
            var found = false;
            if (me.root.id === "-1_-1") {
                for (var j = 0; j < me.root.children.length && !found; j++) {
                    var parent = d.parent;
                    while (parent !== me.root && !found) {
                        if (parent === me.root.children[j]) {
                            rootvalue = me.root.children[j].value;
                            found = true;
                        }
                        parent = parent.parent;
                    }
                }
            } else {
                rootvalue = me.root.value;
            }
            d.isCalculatedRoot = false;
            if ((d.depth <= 1 && d.parent.id === "-1_-1" || (d === me.root))) { //usually node at the beginning is 100%
                if (d.specialChildren && d.specialChildren.length >= 1 && d.specialChildren[0].value > d.value) {
                    d.percentOfParent = d.value / d.specialChildren[0].value;
                    d.subTreePercent = d.percentOfParent;
                    d.pricePercentOfParent = d.percentOfParent;
                    d.percentOfParent = d.pricePercentOfParent;
                    d.isCalculatedRoot = false;
                } else {
                    d.percentOfParent = 1;
                    d.subTreePercent = 1;
                    d.pricePercentOfParent = 1;
                    d.priceSubTreePercent = 1;
                    d.isCalculatedRoot = true;
                }
            } else if (d.isSpecialChild === true && (d.varname === "RULE" || d.isSumSig) && (d.isTotal === true && d.isGenerator === "False") && (d.value > rootvalue)) {
                //if the node has multiple parents and is a rule and a sumSignal, chance is high that it is the main node 
                d.isCalculatedRoot = true;
                d.percentOfParent = 1;
                d.subTreePercent = 1;
                d.pricePercentOfParent = 1;
                d.priceSubTreePercent = 1;
                var temp = d.parent;
                while (temp.depth >= 1) { //need to go through all parent nodes
                    if (temp.isGenerator === "True") {
                        if (temp.children && temp.children.length > 1) {
                            var childSum = 0;
                            var childPrice = 0;
                            for (var i = 0; i < temp.children.length; i++) {
                                if (temp.children[i].isGenerator === "False" && temp.children[i] !== d) {
                                    childSum += temp.children[i].value;
                                    childPrice += temp.children[i].price;
                                }
                            }
                            if (d.value !== 0) {
                                temp.percentOfParent = (temp.value - childSum) / d.value;
                                temp.subTreePercent = (temp.value - childSum) / d.value;
                                temp.pricePercentOfParent = (temp.price - childPrice) / d.price;
                                temp.priceSubTreePercent = (temp.price - childPrice) / d.price;
                            }
                        } else {
                            temp.percentOfParent = temp.value / d.value;
                            temp.subTreePercent = temp.value / d.value;
                            //PRICES
                            temp.pricePercentOfParent = temp.price / d.price;
                            temp.priceSubTreePercent = temp.price / d.price;
                            temp.priceCircleSize = temp.pricePercentOfParent * 30.75 + 9;
                        }
                    } else {
                        if (d.value !== 0) {

                            temp.percentOfParent = temp.value / d.value;
                            temp.subTreePercent = temp.value / d.value;
                            //PRICES
                            temp.pricePercentOfParent = temp.price / d.price;
                            temp.priceSubTreePercent = temp.price / d.price;
                            temp.priceCircleSize = temp.pricePercentOfParent * 30.75 + 9;
                        }
                    }
                    temp = temp.parent;
                    window.d3.select("#node" + temp.id).datum(temp);
                }
            } else if ((d.depth <= 1 && (me.root.signalid === "-1")) && me.hasChildStatus(d.childStatus, me.ENUM_CHILD_STATUS.SPECIAL_SHOWN)) {
                if (d.specialChildren && d.specialChildren.length >= 1 && d.specialChildren[0].value !== 0) {

                    d.percentOfParent = d.value / d.specialChildren[0].value;
                    d.subTreePercent = d.value / d.specialChildren[0].value;
                    d.pricePercentOfParent = d.price / d.specialChildren[0].price;
                    d.priceSubTreePercent = d.price / d.specialChildren[0].price;
                }
            } else { //normal node Standard case
                if (d.measureunit !== d.parent.measureunit) {
                    d.percentOfParent = 1;
                    d.pricePercentOfParent = 1;

                    d.subTreePercent = 1 * d.parent.subTreePercent;
                    d.priceSubTreePercent = 1 * d.parent.subTreePercent;
                } else {
                    if (d.parent.value !== 0) {
                        d.percentOfParent = d.value / d.parent.value;
                        d.pricePercentOfParent = d.price / d.parent.price;
                        d.subTreePercent = d.percentOfParent * d.parent.subTreePercent;
                        d.priceSubTreePercent = d.pricePercentOfParent * d.parent.priceSubTreePercent;
                    }
                }
            }
        } else {
            d.percentOfParent = 0;
            d.subTreePercent = 0;
            window.d3.select("#node" + d.id).select(".nodeSub").classed("none", true);
        }

        if (d.containsNull === true || d.plausible === false || d.valid === false || d.noData === true) {
            window.d3.select("#node" + d.id).select(".nodeErr").classed("none", false);
            if (!me.settings.data.archiveParam) {
                window.d3.select("#node" + d.id).select(".nodeName").attr("x", me.nodeWidth - 75);
                window.d3.select("#node" + d.id).select(".nodeValues").attr("x", me.nodeWidth - 75);
                window.d3.select("#node" + d.id).filter(function (d) { return !me.filterLeaveNodes(d, me); }).classed("woSub", true).select(".nodeName").attr("x", me.nodeWidth - 50);
                window.d3.select("#node" + d.id).filter(function (d) { return !me.filterLeaveNodes(d, me); }).select(".nodeValues").attr("x", me.nodeWidth - 50);
                window.d3.select("#node" + d.id).filter(function (d) { return !me.filterLeaveNodes(d, me); }).select(".nodeErr").attr("dx", me.nodeWidth - 45);

            } else {
                window.d3.select("#node" + d.id).select(".nodeName").attr("x", me.nodeWidth).attr("dx", function (d) {
                    if (me.settings.OnlyFirstLevel === true) {
                        if (d.depth === 2) {
                            return + 30;
                        } else {
                            return - 30;
                        }
                    } else {
                        return +30;
                    }
                });
                window.d3.select("#node" + d.id).select(".nodeValues").attr("x", me.nodeWidth).attr("dx", function (d) {
                    if (me.settings.OnlyFirstLevel === true) {
                        if (d.depth === 2) {
                            return 30;
                        } else {
                            return - 30;
                        }
                    } else {
                        return +30;
                    }
                });
                window.d3.select("#node" + d.id).select(".nodeErr").attr("x", me.nodeWidth).attr("dx",
                    function (d) {
                        if (me.settings.OnlyFirstLevel === true) {
                            if (d.depth === 2) {
                                return + 5;
                            } else {
                                return - 25;
                            }
                        } else {
                            return + 5;
                        }
                    });
            }

        } else {
            window.d3.select("#node" + d.id).select(".nodeErr").classed("none", true);
            window.d3.select("#node" + d.id).select(".nodeInfo").attr("dy", "0.5em").attr("x", 0).attr("dx", me.nodeWidth - 20);
            if (!me.settings.data.archiveParam) {
                window.d3.select("#node" + d.id).select(".nodeName").attr("dy", "-0.2em").attr("dx", 0).attr("x", me.nodeWidth - 50);
                window.d3.select("#node" + d.id).select(".nodeValues").attr("dx", 0).attr("x", (me.nodeWidth - 50));
                window.d3.select("#node" + d.id).filter(function (d) { return !me.filterLeaveNodes(d, me); }).classed("woSub", true).select(".nodeName").attr("x", me.nodeWidth - 30);
                window.d3.select("#node" + d.id).filter(function (d) { return !me.filterLeaveNodes(d, me); }).select(".nodeValues").attr("x", me.nodeWidth - 30);
            } else {
                window.d3.select("#node" + d.id).select(".nodeName").attr("x", me.nodeWidth).attr("dx", function (d) {
                    if (me.settings.OnlyFirstLevel === true) {
                        if (d.depth === 2) {
                            return 5;
                        } else {
                            return -5;
                        }
                    } else {
                        return 0;
                    }
                });
                window.d3.select("#node" + d.id).select(".nodeValues").attr("x", me.nodeWidth).attr("dx", function (d) {
                    if (me.settings.OnlyFirstLevel === true) {
                        if (d.depth === 2) {
                            return 5;
                        } else {
                            return -5;
                        }
                    } else {
                        return 0;
                    }
                })

            }
        }

        return true;
    } catch (ex) {
        me.writeError("sankey.calculatePercentages", ex); return false;
    }
};

vcTopologySankey.prototype.callSubSignalInfo = function (me, d) {
    /// <summary>ClickHandler function that calls the VisualCoreService and shows the signalinformation dialog</summary>.DropdownHandler
    /// <param name="d" type="node">the node clicked, actually needed is only the signalid</param>
    try {
        if (me.error) {
            return false;
        }

        window.VisualCoreService.getVisualBaseByName("VC_CHART_SUBSIGNALS", "analogInfo", window.getCurrentTimestamp(), 500, 1200, JSON.stringify(window._rampMenu.param), JSON.stringify({ "signalID": d.signalid, "signalCount": d.count }), 1,
            function (result) {
                me.dialog.dialog("option", { "title": me.settings.resources.sigInfo, "draggable": true, "width": "1250", "height": 650, "modal": true, "autoResize": true });
                me.dialog.html(result).dialog("open");
            }
        );
        return true;
    } catch (ex) {
        me.writeError("sankey.callSubSignalInfo", ex);
        return false;
    }
};

vcTopologySankey.prototype.setValueText = function (me, d) {
    /// <summary>updates the values for the assigned signals </summary>
    /// <param name="me" type="this">the current object</param>
    /// <param name="d" type="node">the current node to change the text for</param>
    try {
        if (me.error) {
            return false;
        }
        var sRet = "";
        if (parseInt(d.signalid, 10) !== -1) {
            var price = d.price;
            var sPrice = price.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " ";
            var value = d.value;
            var percent;
            var sValue = value.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " ";
            //var sValue = value.toFixed(2) + " ";
            //sValue.toLocaleString('en-US');
            if (d.noData === true) {
                sRet = "----";
            } else {
                if (d.parent.isGenerator === "False") {
                    percent = d.subTreePercent * 100;
                } else {
                    percent = d.percentOfParent * 100;
                }

                var sPercent = percent.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " %";
                if (sPercent === "NaN %") {
                    sPercent = "--";
                }
                if (me.settings.isPrice) {
                    sRet = sPrice;
                } else {
                    sRet = sValue;
                }
                sRet += d.measureunit.toString() + " - " + sPercent;
            }

            //if (d.containsNull === true) {
            //sRet += "<tspan class='nodeWarning spanText'>" "</tspan>"; 
            //}
        }

        return sRet;
    } catch (ex) {
        me.writeError("sankey.setValueText", ex); return false;
    }

};
vcTopologySankey.prototype.updateNode = function (nodeUpdate) {
    /// <summary>special function called when a node is updated e.g. gets a new value </summary>
    /// <param name="me" type="this">the node that is to be changed</param>
    var me = this;
    try {
        if (me.ieVersion === -1 || me.ieVersion > 11) {
            nodeUpdate.select(".nodeValue").text(function (d) { return me.setValueText(me, d); });

        } else {
            nodeUpdate.select(".nodeValues").text(function (d) { return me.setValueText(me, d); });
        }
        nodeUpdate.select(".nodeName").text(function (d) { return d.name; });

        window.d3.selectAll(".node").filter(function (d) { return (me.filterRootNode(d) && d.valid === false) }).classed("err-visible", true);
        window.d3.selectAll(".node").filter(function (d) {
            return (me.filterRootNode(d) && d.plausible === false);
        }).classed("err-visible", true);



        //window.setTimeout(me.setWarning(), 100);
        return true;
    } catch (ex) {
        me.writeError('sankey.updateNode', ex);
        return false;
    }

};

vcTopologySankey.prototype.updateLink = function () {
    /// <summary>special function called when a link is updated e.g. gets bigger/smaller </summary>
    var me = this;
    var linkWidth, linkMinStrength;
    try {
        linkWidth = 50;
        linkMinStrength = 2;
        window.d3.selectAll(".link").attr("style",
            function (d) {

                var sRet = "";
                if (!(d.source.value === 0 || d.target.value === 0)) {

                    sRet += "stroke-width:";
                    if (d.target.isCalculatedRoot === true) {
                        sRet += (d.source.subTreePercent * linkWidth + linkMinStrength);
                    } else if (d.source.isGenerator === "True") {
                        sRet += Math.min((d.target.percentOfParent * linkWidth + linkMinStrength), 80);
                    } else {
                        sRet += Math.min((d.target.subTreePercent * linkWidth + linkMinStrength), 80);
                    }
                    sRet += "px;";
                    var cat;
                    if (!(me.settings.data.OnlyFirstLevel === true && d.source.Color !== null && d.source.Color !== "")) {
                        window.d3.select("#myPattern").classed("none", false);
                        if (d.target.isCalculatedRoot === true) {
                            cat = parseInt(d.source.subTreePercent * 5, 10);
                            if (cat > 4) {
                                cat = 5;
                            }
                            sRet += "stroke:" + me.categoryColors[cat];
                        } else {
                            //5 because of the 5 categories I am in as e.g. 0.19 * 5 = 0.95 == cat0 and so on 
                            cat = parseInt(d.target.subTreePercent * 5, 10);
                            if (cat > 4) {
                                cat = 5;
                            }
                            sRet += "stroke:" + me.categoryColors[cat];
                        }
                    } else {
                        sRet += "stroke:" + d.source.Color + "; stroke-opacity:0.8";
                    }
                } else {
                    if (me.settings.data.OnlyFirstLevel === true && d.source.Color !== null && d.source.Color !== "") {
                        me.categoryColors[0] = d.source.Color;
                        sRet += " stroke-opacity:0.8; ";
                    }
                    sRet += "stroke-width:1px; stroke:" + me.categoryColors[0] + "; ";

                }
                return sRet;
            });

        return true;
    } catch (ex) {
        me.writeError('sankey.updateLink', ex);
        return false;
    }
};
vcTopologySankey.prototype.resetView = function (value) {
    /// <summary>
    ///  function called to set the startpoint to the normal root and <br />
    ///  calls the base method to actually do most of the resetting
    ///</summary>
    var me = this;
    try {
        me.selStart.find("#selStartPoint li").removeClass("selected");
        me.selStart.find("#selStartPoint li:first-child").data("selected", true).addClass("selected");
        me.selStart.find("#selStartPoint").trigger("click");
        window.vcSignalTopology.prototype.resetView.call(me, value);
        return true;
    } catch (ex) {
        me.writeError("sankey.resetView", ex);
        return false;
    }
};


vcTopologySankey.prototype.doEvent = function (event) {
    /// <summary>
    ///  override method of template doEvent to listen for Events called by the menu <br />
    ///  *topo_reset_view - to reset the view <br />
    ///  *topo_full_screen - to to toggle the fullscreen <br />
    ///  *sankey_reload_values - to reload the sankey tree <br/>
    ///  *sankey_toggle_price (with event param bShowPrice) - to tell the sankey to use prices <br />
    ///</summary>
    var me = this;
    try {
        window.vcSignalTopology.prototype.doEvent.call(me, event);
        switch (event.msg) {
            case 'topo_reset_view':
                me.resetView();
                break;
            case 'topo_full_screen':
                //me.isNormalScreen = !me.isNormalScreen;
                me.setFullScreen(!me.isNormalScreen);
                break;
            case 'sankey_reload_values':
                //me.visual.find("#selStartPoint .button-active").trigger("click");
                me.addSankeyValues();
                break;
            case 'sankey_toggle_price':
                me.switchFromToPrice(event.values.bShowPrice);
                break;
            default:
                break;
        }
        return true;
    } catch (ex) {
        me.writeError('doEvent', ex);
        return false;
    }
};
vcTopologySankey.prototype.switchFromToPrice = function (bUsePrices) {
    ///<summary>
    ///toggles the price view by changing the setting <br />
    ///and updating the tree without changing anything else
    ///</summary>
    ///<param name='bUsePrice' type='boolean'>True, if prices are to be used, false otherwise</param>
    var me = this;
    try {
        me.settings.isPrice = bUsePrices;
        return true;
    } catch (ex) {
        me.writeError("switchToPrices", ex);
        return false;
    }
};
vcTopologySankey.prototype.addSankeyValues = function () {
    ///<summary>
    ///adds the values to the tree <br/>
    ///it does so by getting the chart params from the menu <br/>
    ///setting the options and sending everything to the VisualcorService
    ///</summary>
    var me = this;
    try {

        if (window._rampMenu) {
            window._rampMenu.generateChartParameter();
        }
        if (me.settings.data.archiveParam) {
            me.updOptions = me.settings.data.archiveParam;
            me.updOptions.assigned = me.myData;
        } else {
            me.updOptions = {
                interval: window._rampMenu.interval,
                datatype: window._rampMenu.param.datatype,
                startDate: window._rampMenu.param.startDate,
                endDate: window._rampMenu.param.endDate,
                UsePrices: window._rampMenu.param.usePrices,
                assigned: me.myData,
                dateUserDef: window._rampMenu.param.dateUserDef,
              

            };
        }
       
        $(".sankeySignal").html(me.settings.resources.loading);
        $(".sankeyDate").html("");

        window.VisualCoreService.updateData(185,
            me.vcgid,
            window.getCurrentTimestamp(),
            0,
            0,
            '',
            '',
            1,
            2,
            JSON.stringify(me.updOptions),
            function (result) {
                var res = JSON.parse(result);
              
                if (res.hasError === false) {
                    if (res.completeTree === null) {
                        me.visual.find("#start, #divTreeTop, .Topo,.rampSankey ").show();
                        me.visual.find("#treeHolder").show();
                        me.visual.find("#baseHeader .sankeySignal,#baseHeader .sankeyDate, #baseHeader .sankeyValue")
                            .show();
                        if (window._rampMenu) {
                            $(".sankeySignal").html(res.assigned.children[0].tooltipName);
                            $(".sankeyDate").html(res.assigned.children[0].tooltipDate);
                            window._rampMenu.setDirty(false);

                        }
                        me.settings.isPrice = me.updOptions.UsePrices;


                        me.visit(res.assigned,
                            function (d) {
                                me.selStart.find("#selStartPoint li[data-value='" + d.id + "']").data("data-node", d);
                            },
                            function (d) {
                                //d.name = d.tooltipName;
                                return d.children && d.children.length > 0 ? d.children : null;
                            },
                            me);

                      
                         me.setStartNode((me.settings.data.OnlyFirstLevel === false && me.nodes.length >= 15));


                        me.updateTree(res.assigned, true);
                        //me.setWarning();
                        //window.setTimeout(me.setWarning(), 2000);

                        //
                        //me.selStart.find("#selStartPoint li:first-child").data("selected", true).addClass("button-active");

                        me.selStart.find("#selStartPoint .selected").trigger("click");

                    } else {
                        me.showInfo(res.completeTree, "", true);

                    }
                    //switchFromToPrice(me.updOptions.usePrices);
                } else {
                    me.visual.find("#start").hide();

                    me.visual.find("#treeHolder, .Topo,.rampSankey ").hide();
                    me.visual.find("#baseHeader .sankeySignal,#baseHeader .sankeyDate, #baseHeader .sankeyValue")
                        .hide();
                    me.showInfo(res.completeTree, "", false);
                    //window.$("#baseHeader").append("<div class='note'>" +res.completeTree +"</div>");
                }
                if (me.settings.data.OnlyFirstLevel === true &&
                    $("#treeHolder").width() >= me.COCKPIT_START_SCALE_MIN_WIDTH) {
                  

                } else {
                    if (me.nodes.length < 15) {
                        me.SetCockpitStartZoom(me.COCKPIT_START_SCALE_SMALL, me.COCKPIT_START_SCALE_ADJUST_ALIGNMENT_SMALL);
                    } else {
                        me.SetCockpitStartZoom(me.COCKPIT_START_SCALE_XSMALL, me.COCKPIT_START_SCALE_ADJUST_ALIGNMENT_XSMALL);

                    }

                }



            });

    } catch (ex) { me.writeError('sankey.addSankeyValues', ex); return false; }
    return true;
};
vcTopologySankey.prototype.SetCockpitStartZoom = function (dblStartScale, iStartAdjustalignment) {
    var me = this;
    try {
        ///MASSIVE HACK FOR KELAG
        var y = -me.root.x0;
        var add;
        var x = -me.root.y0;
        // add = (window.d3.select("#overlay").node().getBoundingClientRect().width - window.d3.select("#tree").node().getBoundingClientRect().width)/2;
        add = $("#treeHolder").width() / 2;
        if (me.root.id === "-1_-1" && me.source.indexOf("Dependency") === -1) {
            add -= (me.nodeWidth * dblStartScale + (me.nodeWidth * dblStartScale / 2)) +
                iStartAdjustalignment;

        } else if (me.source.indexOf("Dependency") === -1) {
            add -= (me.nodeWidth / 2);
        } else if (me.source.indexOf("Dependency") > -1) {

            add -= me.nodeWidth * dblStartScale;
        }
        x = x * dblStartScale + add;

        var half = $("#treeHolder").height() / 2;
        y = y * dblStartScale + half;

        window.d3.select('g#tree').transition().duration(me.duration).attr("transform",
            "translate(" + x + "," + y + ")scale(" + dblStartScale + ")");
        me.zoomListener.scale(dblStartScale);
        me.zoomListener.translate([x, y]);
    } catch (ex) {
        me.writeError('sankey.SetCockpitStartZoom', ex);
    }
};
vcTopologySankey.prototype.setStartNodeListElementClick = function (me, event, bAdjustNodeToLeft) {
    try {
      
        me.selStart.find("#selStartPoint li").data("selected", false).removeClass("selected inactive");
        if (window.$(".vc-filter").val().trim().length > 0) {
            me.selStart.find("#selstartpoint li").not(".found").hide();
        }

        window.$(event.currentTarget).addClass("selected").data("selected", true);

        me.visit(window.$(event.currentTarget).data("data-node"),
            me.calculateSankeyPercentages,
            function (d) {
                return d.children && d.children.length > 0 ? d.children : null;
            },
            me);
        var node = window.$(event.currentTarget).data("data-node");
        if (me.hasChildStatus(node.childStatus, me.ENUM_CHILD_STATUS.SPECIAL_SHOWN)) {

            node._specialChildren = node.specialChildren;
            node.specialChildren = null;
            node = me.removeChildStatus(node, me.ENUM_CHILD_STATUS.SPECIAL_SHOWN);
            node = me.setChildStatus(node, me.ENUM_CHILD_STATUS.SPECIAL_HIDDEN);
        }
       
        me.updateTree(node, true);
        me.centerNode(node, bAdjustNodeToLeft);
        me.svgGroup.selectAll("path.link.additionalParentLink").filter(function (d) {
            if (d.target.nodeStatus === me.ENUM_NODE_STATUS.HIDDEN ||
                d.source.nodeStatus === me.ENUM_NODE_STATUS.HIDDEN ||
                me.hasChildStatus(d, me.ENUM_CHILD_STATUS.SPECIAL_HIDDEN)) {
                me.linkRemoved = true;
                return true;
            } else {
                me.linkRemoved = false;
                return false;
            }
        }).remove();
        if (window._rampMenu) {
            $(".sankeySignal").html(me.root.tooltipName);
            $(".sankeyDate").html(me.root.tooltipDate);

        } else {
            $(".sankeySignal").html(me.root.children[0].tooltipName);
            $(".sankeyDate").html(me.root.children[0].tooltipDate);

        }
        me.setRemoved();
    } catch (ex) {
        me.writeError('sankey.setStartNodeListElementClick', ex);
    }
    //window.setTimeout(me.setWarning(), 2000);
};

vcTopologySankey.prototype.setStartNode = function (bAdjustNodeToLeft) {
    ///<summary>
    ///used to change the Start of the Sankey to another Node<br/>
    ///only Valid for Nodes with Children, it selects the Node from the Tree and draws it anew <br/>
    ///For selection it uses a dropdown with the valid nodes
    ///</summary>
    var me = this;
    try {
     
        me.visual.find(".note.err").remove();
        me.selStart.find("#selStartPoint li").off("click").on("click", function (event) { me.setStartNodeListElementClick(me, event, bAdjustNodeToLeft); });

    } catch (ex) {
        me.writeError('sankey.setStartNode', ex);
        return false;
    }
    return true;
};


vcTopologySankey.prototype.setRemoved = function () {
    var me = this;
    try {

        window.$("#baseHeader").find(".error").remove();

        if (me.linkRemoved) {
            window.$("#baseHeader").append("<div class='error'>" +
                me.settings.resources.attentionLinkRemoved_lbl +
                "</div>");
            //me.divRem.show();
        } else {
            me.showInfo("", "", false);

        }
    } catch (ex) {
        me.writeError('sankey.setRemoved', ex);
        return false;
    }
    return true;
}
vcTopologySankey.prototype.addValidStartNodesToDropdown = function (d, me) {
    ///<summary>
    ///used to add the Nodes applicable for Start to the dropdown<br/>
    ///it attaches itself to the filter function and adds each Node as Option + a "Reset" Option
    ///</summary>
    try {
        var opt;
        if (me.selStart.find("#selStartPoint li i[data-id='" + d.signalid + "']").length > 0) {

            opt = $("<li>",
                {
                    "data-value": d.id,
                    "html": d.icon + d.name + " <span>(" + (me.selStart.find("#selStartPoint li i[data-id='" + d.signalid + "']").length + 1) + ")</span><i class='btnSignalInfo fa-regular fa-info-circle color-font-secondary vc-list-icon' style='float:right' data-id='" +
                        d.signalid +
                        "'></i>"
                }).addClass("vc-list-item");
        } else {

            opt = $("<li>", {
                "data-value": d.id,
                "html": d.icon + d.name + "<i class='btnSignalInfo fa-regular fa-info-circle color-font-secondary vc-list-icon' style='float:right' data-id='" + d.signalid + "'></i>"
            }).addClass("vc-list-item");
        }


        opt.data("data-node", d);
        opt.data("data-sort", parseInt(d.sortid, 10));
        me.selStart.find("#selStartPoint").append(opt);
        var listitems = me.selStart.find("#selStartPoint").children('li').get();
        listitems.sort(function (a, b) {
            var compA = window.$(a).data("data-sort");
            var compB = window.$(b).data("data-sort");
            return (compA < compB) ? -1 : (compA > compB) ? 1 : 0;
        });
        window.$.each(listitems, function (idx, itm) { me.selStart.find("#selStartPoint").append(itm); });
        me.selStart.show();
    } catch (ex) {
        me.writeError('sankey.addValidStartNodesToDropdown', ex);
        return false;
    }
    return true;
};

vcTopologySankey.prototype.clone = function (obj) {
    ///<summary>
    ///helper function to make a deep copy of an object
    ///</summary>
    var me = this;
    try {
        if (obj === null || typeof (obj) !== 'object' || 'isActiveClone' in obj)
            return obj;
        var temp = obj.constructor(); // changed
        for (var key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                obj.isActiveClone = null;
                temp[key] = me.clone(obj[key]);
                delete obj.isActiveClone;
            }
        }
        return temp;
    } catch (ex) {
        me.writeError("sankey.cloneObj", ex);
        return false;
    }
};

vcTopologySankey.prototype.filterSignalList = function () {
    /// <summary>
    ///  This function shows/hides items of the given list. 
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        //hide all
        me.visual.find(".vc-list-table .vc-list-item").removeClass("found").data("counter", 0).hide();

        //we add the 'found' class to all items we want to filter based on the vcfilter tags
        me.setTagFilter(".vc-filter", ".vc-list-table .vc-list-item", "found");

        me.visual.find(".vc-list-table .vc-list-item.found").show();
        me.visual.find(".vc-list-table .vc-list-item").removeClass("alt");
        me.visual.find(".vc-list-table .vc-list-item.found:even").addClass("alt");

        return true;
    } catch (ex) {
        me.writeError('vcTopologySankey.filterList', ex);
        return false;
    }

};

vcTopologySankey.prototype.callMenuItemInfo = function (element) {

    var me = this;
    try {
        me.vcVisual.showSignalAnalogSummaryDialog($(element).data("id"));
    } catch (ex) {
        me.writeError("vcTopologySankey.callMenuItemInfo", ex);
    }
};